import './_main/prism.js';
import './_plugin/prism-line-highlight.js';
import './_plugin/prism-line-numbers.js';
import './_plugin/prism-autolinker.js';
import './_plugin/prism-data-uri-highlight.js';
import './_plugin/prism-show-invisibles.js';
import './_plugin/prism-wpd.js';
import './_plugin/prism-custom-class.js';
import './_plugin/prism-file-highlight.js';
import './_plugin/prism-toolbar.js';
import './_plugin/prism-show-language.js';
import './_plugin/prism-jsonp-highlight.js';
import './_plugin/prism-highlight-keywords.js';
import './_plugin/prism-remove-initial-line-feed.js';
import './_plugin/prism-inline-color.js';
import './_plugin/prism-previewers.js';
import './_plugin/prism-autoloader.js';
import './_plugin/prism-unescaped-markup.js';
import './_plugin/prism-normalize-whitespace.js';
import './_plugin/prism-keep-markup.js';
import './_plugin/prism-command-line.js';
import './_plugin/prism-copy-to-clipboard.js';
import './_plugin/prism-download-button.js';
import './_plugin/prism-match-braces.js';
import './_plugin/prism-diff-highlight.js';
import './_plugin/prism-filter-highlight-all.js';
import './_plugin/prism-treeview.js';
import './language/prism-diff.js';

// Configure the Prism Autoloader
if (Prism.plugins.autoloader) {
  Prism.plugins.autoloader.languages_path = '/asset/js/module/prism/language/';
}
